import React, { useContext } from 'react'
import { LINK_IMAGE_TO_PROJECT, UNLINK_IMAGE_FROM_PROJECT } from 'api/projects'
import { AssetManagerContext } from './AssetManagerContext'

export function useAssetManager(passAllArgs = false) {
    const { setIsOpen, setPlaceImage, projectId, pageId, blockId, useAbsoluteLink } = useContext(AssetManagerContext)

    const chooseAsset = (value, onPlaceImage, localBlockId) => {
        const onPlaceImageWrapper = (data, isThirdParty) => {
            if (isThirdParty || useAbsoluteLink) {
                const args = passAllArgs ? data : data.src
                onPlaceImage(args)
            } else {
                LINK_IMAGE_TO_PROJECT({
                    projectId,
                    imageId: data.id,
                    pageId,
                    blockId: blockId || localBlockId,
                    previousImageKey: value,
                }).then(linkedImage => {
                    const args = passAllArgs ? { ...data, src: linkedImage.imageKey } : linkedImage.imageKey
                    onPlaceImage(args)
                })
            }
        }
        setPlaceImage({ callback: onPlaceImageWrapper })
        setIsOpen(true)
    }

    const deleteAsset = (value, onPlaceImage) => {
        const isRelativeLink = value && !value.includes('http')
        if (isRelativeLink)
            UNLINK_IMAGE_FROM_PROJECT({
                projectId,
                pageId,
                blockId,
                imageKey: value,
            }).then(() => {
                onPlaceImage('')
            })
        else onPlaceImage('')
    }

    return { chooseAsset, deleteAsset }
}
